<template>
  <div v-if="masterCampaign">
    <vx-card>
      <h3 class="mr-4">Campaign statistics</h3>
      <p class="mt-2">
        The overall email statistics for the entire campaign. <br />
        Note: It can take up to a few minutes before statistics are available. <br />
        <span v-if="masterCampaignStatistics"
          >Showing stats for the period {{ startDate }} - {{ endDate }}</span
        ><br />
        <!-- Click a specific venue campaign to view statistics for that -->
      </p>

      <vs-row class="mt-2">
        <vs-button @click="fetchStats">Refetch statistics</vs-button>
      </vs-row>

      <vs-row class="mt-5 mb-4" vs-justify="center">
        <vs-col vs-w="2" class="px-4" v-for="statsCard in statsCardList" :key="statsCard.name">
          <vs-tooltip position="bottom" delay="140ms" :text="statsCard.tooltip">
            <vs-card class="mb-0">
              <vs-row vs-justify="space-between">
                <span class="mt-5 ml-3">
                  <feather-icon
                    :icon="statsCard.icon"
                    svgClasses="h-7 w-7 mb-1 stroke-current text-primary"
                  />
                </span>
                <span class="text-2xl mt-3 mr-5">
                  <b>{{ statsCard.number }}</b>
                </span>
              </vs-row>
              <vs-row class="mt-6">
                <h5 class="ml-3">{{ statsCard.name }}</h5>
              </vs-row>
            </vs-card>
          </vs-tooltip>
        </vs-col>
      </vs-row>

      <vue-apex-charts
        v-if="masterCampaignStatistics && !loading"
        height="500"
        type="line"
        :options="options"
        :series="series"
      ></vue-apex-charts>

      <div
        v-if="!masterCampaignStatistics || loading"
        id="div-with-loading"
        style="height: 500px"
        class="vs-con-loading__container"
      ></div>

      <!-- <div class="data-list-container data-list-list-view">
        <vs-table ref="table" class="mt-8" v-model="selected" pagination search :data="approvedCampaigns">
          <template slot="thead">
            <vs-th>Venue name</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>VM fill out by</vs-th>
            <vs-th>Send by</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                <vs-td>
                  <p class="product-name font-medium truncate">
                    {{ tr.venueId }}
                  </p>
                </vs-td>
                <vs-td>
                  <vs-chip :color="statusObject(tr.status).color" class="product-order-status">
                    {{ statusObject(tr.status).text }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ moment(tr.approvedByDate).format("DD-MM-yyyy") }}
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">
                    {{ moment(tr.sendByDate).format("DD-MM-yyyy") }}
                  </p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div> -->
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";
import VueApexCharts from "vue-apexcharts";
import _ from "lodash";

export default {
  components: { VueApexCharts },
  mixins: [campaignMixin],
  props: ["masterCampaign"],
  data() {
    return {
      moment,
      selected: [],
      loading: true,
    };
  },
  methods: {
    async fetchStats() {
      this.loading = true;
      setTimeout(() => {
        this.$vs.loading({
          container: "#div-with-loading",
        });
      }, 200);

      try {
        await this.$store.dispatch("masterCampaigns/getStatistics", this.masterCampaign.id);
      } catch {
        this.$vs.notify({
          color: "danger",
          title: "Statistics unavailable",
          text: "It might take a few minutes before statistics are available. Try again in a few minutes.",
        });
      } finally {
        this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      masterCampaignStatistics: "masterCampaigns/masterCampaignStatistics",
    }),

    statsCardList() {
      return [
        {
          name: "Processed",
          icon: "CpuIcon",
          number: !this.masterCampaignStatistics
            ? 0
            : _.sumBy(this.masterCampaignStatistics, e => e.stats[0].metrics.processed),
          tooltip: "Total number of emails sent for this campaign in this period",
        },
        {
          name: "Delivered",
          icon: "MailIcon",
          number: !this.masterCampaignStatistics
            ? 0
            : _.sumBy(this.masterCampaignStatistics, e => e.stats[0].metrics.delivered),
          tooltip: "Total number of emails that were succesfully delivered to the guests in this period",
        },
        {
          name: "Opens",
          icon: "BookOpenIcon",
          number: !this.masterCampaignStatistics
            ? 0
            : `${_.sumBy(this.masterCampaignStatistics, e => e.stats[0].metrics.opens)} (${_.sumBy(
                this.masterCampaignStatistics,
                e => e.stats[0].metrics.unique_opens,
              )})`,
          tooltip: "Total number of opened emails in this period. Number in parentheses is the unique count",
        },
        {
          name: "Clicks",
          icon: "ExternalLinkIcon",
          number: !this.masterCampaignStatistics
            ? 0
            : `${_.sumBy(this.masterCampaignStatistics, e => e.stats[0].metrics.clicks)} (${_.sumBy(
                this.masterCampaignStatistics,
                e => e.stats[0].metrics.unique_clicks,
              )})`,
          tooltip: "Total number of clicked links in this period. Number in parentheses is the unique count",
        },

        {
          name: "Bounces",
          icon: "CornerUpLeftIcon",
          number: !this.masterCampaignStatistics
            ? 0
            : `${_.sumBy(this.masterCampaignStatistics, e => e.stats[0].metrics.bounces)} (${_.sumBy(
                this.masterCampaignStatistics,
                e => e.stats[0].metrics.bounce_drops,
              )})`,
          tooltip:
            "Total number of bounces (and bounce drops in parentheses) in this period. A bounce is when the email cannot be delivered, typically because the email is invalid",
        },
        {
          name: "Blocks",
          icon: "ShieldOffIcon",
          number: !this.masterCampaignStatistics
            ? 0
            : _.sumBy(this.masterCampaignStatistics, e => e.stats[0].metrics.blocks),
          tooltip:
            "Total number of blocked emails in this period. This typically means that the mail has been categorized as spam or the sending mail has been blocked",
        },
      ];
    },

    options() {
      return {
        colors: ["#845EC2", "#0089BA", "#D65DB1", "#FF6F91", "#FF9671", "#FFC75F", "#B0A8B9", "#4B4453"],
        xaxis: {
          categories: this.masterCampaignStatistics.map(e => e.date),
        },
      };
    },
    series() {
      return [
        {
          name: "Processed",
          data: this.masterCampaignStatistics.map(e => e.stats[0].metrics.processed),
        },
        {
          name: "Delivered",
          data: this.masterCampaignStatistics.map(e => e.stats[0].metrics.delivered),
        },
        {
          name: "Opens",
          data: this.masterCampaignStatistics.map(e => e.stats[0].metrics.opens),
        },
        {
          name: "Unique opens",
          data: this.masterCampaignStatistics.map(e => e.stats[0].metrics.unique_opens),
        },
        {
          name: "Clicks",
          data: this.masterCampaignStatistics.map(e => e.stats[0].metrics.clicks),
        },
        {
          name: "Unique clicks",
          data: this.masterCampaignStatistics.map(e => e.stats[0].metrics.unique_clicks),
        },
        {
          name: "Bounces",
          data: this.masterCampaignStatistics.map(e => e.stats[0].metrics.bounces),
        },
        {
          name: "Blocks",
          data: this.masterCampaignStatistics.map(e => e.stats[0].metrics.blocks),
        },
      ];
    },
    startDate() {
      if (!this.masterCampaignStatistics) return "";
      return this.masterCampaignStatistics[0].date;
    },
    endDate() {
      if (!this.masterCampaignStatistics) return "";
      return this.masterCampaignStatistics[this.masterCampaignStatistics.length - 1].date;
    },
  },

  async created() {
    console.log("Getting for id", this.masterCampaign.id);
    await this.fetchStats();
  },
};
</script>

<style lang="scss">
</style>
